import { NextRouter } from 'next/router'

import { useSyncAISearchToRouter } from '@/pages/track/searchkeyword/index.hooks'

// because we are using a hook provided from instantsearch inside the useSyncAISearchToRouter hook, we need to put the hook inside its own component so that we can wrap the hook inside of the InstantSearch wrapper on our search page.

// the error we are avoiding is Error: [InstantSearch] Hooks must be used inside the <InstantSearch> component.
const SyncAiSearchToRouter = ({
	router,
	user,
}: {
	router: NextRouter
	user: User
}): JSX.Element => {
	// Sync store changes to URL (adds/removes params based on store state and user interactions)
	useSyncAISearchToRouter(router, user)
	return null
}

export default SyncAiSearchToRouter
